/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { TaskAssignmentType } from '../../enums/task-assignment-type.enum';
import { TaskMetaData } from '../task.model';
export enum FrequencyEnum {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY'
}
export enum DayOfWeek {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY'
}

export interface RecurringDto {
  frequency?: FrequencyEnum;
  execution_days?: string[]; // legacy implementation, moved to options
  options?: RecurringOption;
  timezone?: string;
}

export interface RecurringOption {
  every?: number; // used for repitions, 1, 2, 3 etc.used for daily, weekly, monthly, yearly
  execution_days?: string[];
  execution_day_position?: string;
}

export class ExecutionDto {
  constructor(public task_id: string, public scheduled_at: string) {}
}
export class ScheduledTaskDto {
  constructor(
    public _id: string,
    public workflow_name: string,
    public scheduled_at: string,
    public assigned_to: string[] = [],
    public assigned_to_employee_or_employeegroup: TaskAssignmentType = TaskAssignmentType.EMPLOYEE,
    public executions: ExecutionDto[] = [],
    public task_name?: string,
    public createdAt?: string,
    public updatedAt?: string,
    public recurring?: RecurringDto,
    public meta_data?: TaskMetaData
  ) {}
}
